window.global ||= window;

// An ErrorBoundary only sees render-phase throws. Nearly all data flow in this
// app runs through async Firestore/RTDB callbacks and un-awaited promises, whose
// failures never reach React at all — these two handlers surface those.
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', (event) => {
    console.error('Uncaught error:', event.error ?? event.message);
});